"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.activation.subject': 'Aktywuj swoje konto',
    'email.activation.title': 'Witamy w IntHub!',
    'email.activation.text': 'Dziękujemy za rejestrację w IntHub. Aby ukończyć rejestrację i aktywować konto, kliknij przycisk poniżej.',
    'email.activation.button': 'Aktywuj konto',
};
